// Edit these to point at the real profiles / release.
export const ARTIST = 'Patrick M';

export const LINKS = {
  spotify: 'https://open.spotify.com/artist/42koNzFI5wDTxVdTIYYO3I',
  youtube: 'https://www.youtube.com/@patrickm.mp3',
  instagram: 'https://www.instagram.com/pppatrickm/',
};

export const ALBUM = {
  title: 'WHERE DID EVERYBODY GO?',
  url: 'https://open.spotify.com/album/22UMwwvpjuIiYj1SN4zMuc',
};

export const CONTACT = {
  booking: 'bookings.patrickm@gmail.com',
};
